module.exports = __webpack_public_path__ + "img/mr.379e8212.svg";